import { useCases } from "../../providers/Cases";
import { useCategories } from "../../providers/Categories";
import { usePosts } from "../../providers/Posts";
import { useMedia } from "../../providers/medias";
import {
  Container,
  Content,
  ContentDisplay,
  ContentEmpty,
  Title,
} from "./postBoxStyle";

const PostBox = () => {
  const { actualPost, showPost } = usePosts();
  const { showCategory, category } = useCategories();
  const { showCaseDesc, caseToShow } = useCases();
  const { filterMedia } = useMedia();

  return (
    <Container>
      {showCaseDesc ? (
        <Content>
          <Title
            $backImage={filterMedia(caseToShow.featured_media)}
            dangerouslySetInnerHTML={{ __html: caseToShow.title.rendered }}
          />
          <ContentDisplay
            className="elementor"
            dangerouslySetInnerHTML={{ __html: caseToShow.content.rendered }}
          />
        </Content>
      ) : showPost ? (
        <Content>
          <Title
            $backImage={filterMedia(actualPost.featured_media)}
            dangerouslySetInnerHTML={{ __html: actualPost.title.rendered }}
          />
          <ContentDisplay
            className="elementor"
            dangerouslySetInnerHTML={{ __html: actualPost.content.rendered }}
          />
        </Content>
      ) : showCategory ? (
        <ContentEmpty>
          <h1>{category.name}</h1>
          <p>{category.description}</p>
        </ContentEmpty>
      ) : (
        <>
          <ContentEmpty>
            <h1>Strategic Legal Intelligence</h1>
            <p>
              A área de Strategic Legal Intelligence (SLI) foi criada em 2015
              para oferecer serviços de business intelligence, outsourcing e
              serviços legais estratégicos aos clientes, atendendo às principais
              necessidades dos departamentos jurídicos. Diante dos mais de 40
              serviços oferecidos na 1ª Geração destacamos o pioneirismo em
              iniciativas de conciliação e mediação; as pesquisas de bens;
              visitas institucionais; e a gestão de depósitos judiciais. Após o
              sucesso dos primeiros anos, a área evoluiu para a 2ª Geração que
              contou com 4 diferentes módulos (Prevenção e Solução de Conflitos;
              Data Driven; More for Less e Performance) que buscavam
              corresponder aos novos desafios vivenciados pelos clientes e pelo
              mercado jurídico. Em 2019, a área incorporou o uso de ferramentas
              com Inteligência Artificial e utilizou instrumentos como a DIANA
              (com foco em análises preditivas e prescritivas) para realizar as
              demandas. Hoje, a SLI entra na terceira fase, onde a convergência
              entre tecnologia, gestão, ferramentas de automação, inteligência
              artificial e a competência de nossos profissionais
              multidisciplinares resultam em 6 módulos de serviços, destacados
              no mapa mental ao lado.
            </p>
          </ContentEmpty>
        </>
      )}
    </Container>
  );
};

export default PostBox;
